"use strict";
import { useMemo } from "react";
import { ALL_CHAIN_IDS } from "features/chains/types";
import { ChainsConfigKey, DynamicConfigs } from "features/gating/configs";
import { useDynamicConfigValue } from "features/gating/hooks";
export function useOrderedChainIds(chainIds) {
  const serverOrderedChains = useDynamicConfigValue(
    DynamicConfigs.Chains,
    ChainsConfigKey.OrderedChainIds,
    ALL_CHAIN_IDS
  );
  return useMemo(() => {
    const orderedChains = serverOrderedChains.filter((c) => chainIds.includes(c));
    const unspecifiedChains = chainIds.filter((c) => !serverOrderedChains.includes(c));
    return [...orderedChains, ...unspecifiedChains];
  }, [serverOrderedChains, chainIds]);
}
